import { StrictMode } from 'react';
import { createRoot } from 'react-dom/client';
import { App } from './App.js';
import { ErrorBoundary } from './components/ErrorBoundary.js';
import './styles/tokens.css';
import './styles/app.css';
import './styles/sign-in.css';
import './styles/tokens-warm.css';
import './styles/subject-picker.css';
import './styles/take-lively.css';
import './styles/standing.css';
import './styles/help.css';
import './styles/contact.css';

const container = document.getElementById('root');
if (!container) throw new Error('#root is missing from index.html');

createRoot(container).render(
  <StrictMode>
    <ErrorBoundary>
      <App />
    </ErrorBoundary>
  </StrictMode>,
);
